import {
  useCreateScoringMutation,
  useUpdateScoringMutation,
} from "../queries/useScoringConfigQuery";

import { useAgentStore } from "../store/agentStore";

import { toast } from "react-toastify";

export function useLeadScoring(agentId, closeModal) {

  const { selectedAgent, setSelectedAgent } = useAgentStore();

  const hasExistingConfig = Boolean(selectedAgent?.scoring_config);


  const createMutation = useCreateScoringMutation();

  const updateMutation = useUpdateScoringMutation();

  const saveScoring = (data) => {
    if (!agentId) return;

    if (hasExistingConfig) {
      return updateMutation.mutate(
        { id: agentId, data },
        {
          onSuccess: (data) => {
            toast.success("Scoring updated successfully");
            setSelectedAgent((prev) => ({
              ...prev,
              scoring_config: data,
            }));
            closeModal();
          },
          onError: () => toast.error("Failed to update scoring"),
        },
      );
    }

    return createMutation.mutate(
      { id: agentId, data },
      {
        onSuccess: (data) => {
          toast.success("Scoring created successfully");
          setSelectedAgent((prev) => ({
            ...prev,
            scoring_config: data,
          }));
          closeModal();
        },
        onError: () => toast.error("Failed to create scoring"),
      },
    );
  };

  return {
    isLoading:
      createMutation.isPending || updateMutation.isPending,
    saveScoring,
    error:
      createMutation.error || updateMutation.error,
  };
}
